'use client';

import AppImage from '@/components/ui/AppImage';

export default function BrandPartnershipsSection() {
  // Placeholder logo data - replace with actual brand logos
  const brandLogos = [
  { id: 'brand_oura_new', src: '/assets/images/Screenshot_2026-06-07_at_4.16.18_PM-1780863382396.png', alt: 'Oura logo' },
  { id: 'brand_turbotax', src: '/assets/images/4-1770583694208.png', alt: 'TurboTax logo' },
  { id: 'brand_creditkarma', src: '/assets/images/3-1770583613938.png', alt: 'Credit Karma logo' },
  { id: 'brand_cerave', src: '/assets/images/9-1770584031707.png', alt: 'CeraVe logo' },
  { id: 'brand_goodmolecules', src: '/assets/images/1-1770583521033.png', alt: 'Good Molecules logo' },
  { id: 'brand_coach', src: '/assets/images/2-1770583539287.png', alt: 'Coach New York logo' },
  { id: 'brand_elf', src: '/assets/images/5-1770583761018.png', alt: 'e.l.f. (eyes lips face) logo' },
  { id: 'brand_hercampus', src: '/assets/images/6-1770583848520.png', alt: 'Her Campus logo' },
  { id: 'brand_sheamoisture', src: '/assets/images/7-1770583904579.png', alt: 'SheaMoisture logo' },
  { id: 'brand_brick', src: '/assets/images/8-1770583955480.png', alt: 'Brick logo' },
  { id: 'brand_wasserman', src: '/assets/images/10-1770584094705.png', alt: 'Wasserman Next Gen logo' },
  { id: 'brand_handshake', src: '/assets/images/11-1770584181377.png', alt: 'Handshake logo' },
  { id: 'brand_poppi', src: '/assets/images/25-1770584554193.png', alt: 'Poppi logo' },
  { id: 'brand_giorgioarmani', src: '/assets/images/Black_White_Modern_Letter_AG_Logo-1771344358882.png', alt: 'Giorgio Armani logo' },
  { id: 'brand_oura', src: '/assets/images/Screenshot_2026-05-03_at_10.46.35_AM-1777819599703.png', alt: 'Oura Ring logo' },
  { id: 'brand_new', src: '/assets/images/Screenshot_2026-05-03_at_10.47.24_AM-1777819648672.png', alt: 'Brand partner logo' },
  { id: 'brand_goodr', src: '/assets/images/Screenshot_2026-05-03_at_10.49.41_AM-1777819785158.png', alt: 'Goodr Sunglasses logo' },
  { id: 'brand_thatsit', src: '/assets/images/Screenshot_2026-05-03_at_10.52.36_AM-1777819959859.png', alt: "That\'s it. logo" }];


  // Brand collaboration videos - Add your YouTube, Vimeo, or direct video URLs here
  const brandVideos = [
  {
    id: 'video_1',
    url: 'https://drive.google.com/file/d/1LIp8P8BiI7SugZz6wjxFJ0x4efKZgCTd/preview',
    title: 'Elf Cosmetics'
  },
  {
    id: 'video_2',
    url: 'https://drive.google.com/file/d/1eU_HrtFeGu3aLtSCwC6LkIAoDO77ZFup/preview',
    title: 'Shea Moisture'
  },
  {
    id: 'video_3',
    url: 'https://drive.google.com/file/d/1O8tct6SuGlmN-K8ysDOrbtbcbi7i_TfA/preview',
    title: 'TurboTax & Credit Karma'
  }];


  // Helper function to determine video type
  const getVideoType = (url: string) => {
    if (!url) return 'none';
    if (url.includes('youtube.com') || url.includes('youtu.be')) return 'youtube';
    if (url.includes('vimeo.com')) return 'vimeo';
    if (url.match(/\.(mp4|webm|mov|ogg)$/i)) return 'direct';
    return 'embed';
  };

  // Helper function to get embed URL
  const getEmbedUrl = (url: string) => {
    if (!url) return '';

    // Convert YouTube watch URL to embed URL
    if (url.includes('youtube.com/watch')) {
      const videoId = url.split('v=')[1]?.split('&')[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }

    // Convert short YouTube URL to embed URL
    if (url.includes('youtu.be/')) {
      const videoId = url.split('youtu.be/')[1]?.split('?')[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }

    // Convert Vimeo URL to embed URL
    if (url.includes('vimeo.com/') && !url.includes('player.vimeo.com')) {
      const videoId = url.split('vimeo.com/')[1]?.split('?')[0];
      return `https://player.vimeo.com/video/${videoId}`;
    }

    return url;
  };

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-foreground mb-6">
            Collaborating With Purpose
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-8">
            Secured <span className="font-bold text-foreground">20+ brand partnerships</span> as a Cornell Student and advocate, bringing values to life through authentic connections.
          </p>
          <div className="inline-flex items-center gap-3 px-8 py-4 bg-secondary rounded-full border border-border">
            <span className="text-4xl font-bold text-foreground">20+</span>
            <span className="text-lg font-medium text-muted-foreground">Brand Collaborations</span>
          </div>
        </div>
        
        <div className="relative mt-16 overflow-hidden">
          <div className="flex animate-infinite-scroll">
            {/* First set of logos */}
            {brandLogos?.map((logo) =>
            <div
              key={logo?.id}
              className="flex-shrink-0 mx-4 flex items-center justify-center transition-all duration-300">
                <AppImage
                src={logo?.src}
                alt={logo?.alt}
                className="h-32 w-auto object-contain transition-all" />
              </div>
            )}
            {/* Duplicate set for seamless loop */}
            {brandLogos?.map((logo) =>
            <div
              key={`${logo?.id}-duplicate`}
              className="flex-shrink-0 mx-4 flex items-center justify-center transition-all duration-300">
                <AppImage
                src={logo?.src}
                alt={logo?.alt}
                className="h-32 w-auto object-contain transition-all" />
              </div>
            )}
          </div>
        </div>

        {/* Brand Collaboration Videos */}
        <div className="mt-20">
          <h3 className="text-3xl font-bold text-foreground text-center mb-12">Example Brand Collaborations</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {brandVideos.map((video) => {
              const videoType = getVideoType(video.url);
              const embedUrl = getEmbedUrl(video.url);

              return (
                <div
                  key={video.id}
                  className="group relative bg-secondary rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-border">

                  <div className="aspect-[9/16] bg-muted">
                    {videoType === 'none' ?
                    <div className="w-full h-full flex items-center justify-center">
                        <div className="text-center p-6">
                          <div className="w-20 h-20 mx-auto mb-4 bg-foreground/5 rounded-full flex items-center justify-center">
                            <svg className="w-10 h-10 text-foreground/40" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
                            </svg>
                          </div>
                          <p className="text-sm font-medium text-muted-foreground">{video.title}</p>
                          <p className="text-xs text-muted-foreground mt-2">Add video URL in code</p>
                        </div>
                      </div> :
                    videoType === 'direct' ?
                    <video
                      className="w-full h-full object-cover"
                      controls
                      preload="metadata">
                        <source src={video.url} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video> :
                    <iframe
                      src={embedUrl}
                      title={video.title}
                      className="w-full h-full"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen />
                    }
                  </div>
                  <div className="px-4 py-3 text-center">
                    <p className="text-base font-semibold text-foreground">{video.title}</p>
                  </div>
                </div>);
            })}
          </div>
        </div>
      </div>
    </section>);

}